import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Navber.css";

import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const AnimatedNavbar = () => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

     const { isAuthenticated ,token} = useSelector((state) => state.auth);

  useEffect(() => {
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100); // small delay for render
      }
    }
  }, [location]);

  // 🔥 Detect Scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

const navItems = [
  { label: "Home", path: "/" ,sectionId: "hero" },
  { label: "About", path: "/", sectionId: "about" },
  { label: "Events", path: "/", sectionId: "events" },
  { label: "Contact", path: "/", sectionId: "contact" },
  { label: "Packages", path: "/packages", sectionId: "packages" },
];

  return (
    <Navbar
      expand="lg"
      fixed="top"
      expanded={expanded}
      className={`custom-navbar ${scrolled ? "scrolled" : ""}`}
    >
      <Container>
        <Navbar.Brand
          className="nav-logo"
          onClick={() => navigate("/")}
        >
          Ganga Kinare <span>Banquet</span>
        </Navbar.Brand>

        <Navbar.Toggle
          onClick={() => setExpanded(expanded ? false : "expanded")}
        />

        <Navbar.Collapse>
          <Nav className="ms-auto nav-links">
            {navItems.map((item, index) => (
<Nav.Link
  key={index}
  className="nav-link-item"
  onClick={() => {
    if (item.sectionId) {
      if (window.location.pathname !== "/") {
        navigate("/", { state: { scrollTo: item.sectionId } });
      } else {
        const element = document.getElementById(item.sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    } else {
      navigate(item.path);
    }

    setExpanded(false);
  }}
>
  {item.label}
</Nav.Link>
            ))}
          </Nav>
        </Navbar.Collapse>


         <img src="/user.png" style={{margin:"0px 20px",width:"30px",backgroundColor:"white",borderRadius:"50%"}}
         onClick={()=>{ isAuthenticated?navigate("/profile"):navigate("/login")}}/>
       
      </Container>


    </Navbar>
  );
};

export default AnimatedNavbar;